/* eslint-disable */
import { ref, watch, computed } from "@vue/composition-api";
export default function useinvoicesList() {
  const refinvoiceListTable = ref(null);

  const perPage = ref(10);
  const totalinvoices = ref(0);
  const currentPage = ref(1);

  const dataMeta = computed(() => {
    const localItemsCount = refinvoiceListTable.value
      ? refinvoiceListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalinvoices.value,
    };
  });

  return {
    perPage,
    currentPage,
    totalinvoices,
    dataMeta,
    refinvoiceListTable,
  };
}
